/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

export const Clock = ( props: SVGProps<SVGSVGElement> ) => (
	<svg viewBox='0 0 24 24' { ...props }>
		<path d='M12 .75c6.213 0 11.25 5.037 11.25 11.25S18.213 23.25 12 23.25.75 18.213.75 12 5.787.75 12 .75zm0 1.5c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm.75 3c.38 0 .693.282.743.648L13.5 6v5.69l3.22 1.932c.36.216.476.682.26 1.042-.199.33-.612.451-.962.302l-.08-.042-3.75-2.25c-.212-.128-.363-.339-.411-.584L11.77 12V6c0-.414.336-.75.75-.75z' />
	</svg>
);
